import { useEffect } from 'react';

import { ActionCreatorWithOptionalPayload } from '@reduxjs/toolkit';

import { useAppDispatch } from '../../../store/hooks';

export const useSetFeatureId = (
  dispatcherAction: ActionCreatorWithOptionalPayload<
    number | undefined,
    string
  >,
  featureId: number
) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(dispatcherAction(featureId));
  }, []);
};
